export function formatDistance(m, lang = "fr") {
  if (m == null) return "";
  if (m < 1000) return `${m} m`;
  const km = m / 1000;
  return `${lang === "en" ? km.toFixed(1) : km.toFixed(1).replace(".", ",")} km`;
}

export function formatRating(r, lang = "fr") {
  const s = Number(r).toFixed(1);
  return lang === "en" ? s : s.replace(".", ",");
}

export function formatChatDate(iso, lang = "fr") {
  if (!iso) return "";
  const locale = lang === "en" ? "en-CA" : "fr-CA";
  const d = new Date(iso);
  const now = new Date();
  const time = d.toLocaleTimeString(locale, { hour: "2-digit", minute: "2-digit" });
  const startOfDay = (x) => new Date(x.getFullYear(), x.getMonth(), x.getDate()).getTime();
  const diffDays = Math.round((startOfDay(now) - startOfDay(d)) / 86400000);
  if (diffDays === 0) return lang === "en" ? `Today, ${time}` : `Aujourd'hui, ${time}`;
  if (diffDays === 1) return lang === "en" ? `Yesterday, ${time}` : `Hier, ${time}`;
  return `${d.toLocaleDateString(locale, { day: "numeric", month: "short" })}, ${time}`;
}
